import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from "@angular/core";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin, Subscription } from "rxjs";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "app-rating-by-site",
  templateUrl: "./rating-by-site.component.html",
  styleUrls: ["./rating-by-site.component.scss"],
})
export class RatingBySiteComponent implements OnInit, OnDestroy {
  private BASE_URL = GlobalVariable;
  reviewsByRating: {
    platformIcon: string;
    ratings: any;
    isShowRating: boolean;
    total: number;
    averageReviewsPerWeek: number;
    averageReviewsPerMonth: number;
  }[] = [];
  loading: boolean;
  startDate: any = null;
  endDate: any = null;
  isGoogleConnected: boolean;
  isFacebookConnected: boolean;
  isZceppaConnected: boolean;
  private _unsubscribe$: Subscription;
  @Output() ratingValueApiResponseChange = new EventEmitter<any>();

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private httpService: DataService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.onInit();
    this._unsubscribe$ = this.commonService.analyticsFilterDateRange$.subscribe(
      (data: any) => {
        this.startDate = null;
        this.endDate = null;
        if (
          data &&
          (data?.applied_from == "REVIEW_DATE_FILTER" ||
            data?.applied_from == "BOTH")
        ) {
          this.startDate = data.start_date;
          this.endDate = data.to_date;
          this.getRatingBySite();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this._unsubscribe$) {
      this._unsubscribe$.unsubscribe();
    }
  }

  async onInit() {
    let { isGoogleConnected, isFacebookConnected, isZceppaConnected } =
      await this.checkConnectedPlatforms();
    this.isGoogleConnected = isGoogleConnected;
    this.isFacebookConnected = isFacebookConnected;
    this.isZceppaConnected = isZceppaConnected;
    this.getRatingBySite();
  }

  checkConnectedPlatforms() {
    const checkZceppaStatus = this.httpService.getRequest({
      customApiUrl: this.BASE_URL.REVIEW_SETUP_VALUE_URL_V2(this.outlet_id),
    });
    const checkConnectedPlatforms = this.httpService.get(
      this.BASE_URL.GOOGLE_RECONNECT_API(this.outlet_id)
    );
    return new Promise<{
      isGoogleConnected: boolean;
      isFacebookConnected: boolean;
      isZceppaConnected: boolean;
    }>((resolve) => {
      forkJoin([checkConnectedPlatforms, checkZceppaStatus]).subscribe(
        (response) => {
          let connectedPlatforms = response[0];
          let zceppaStatus = response[1];
          if (connectedPlatforms.code == 200 && zceppaStatus.code == 200) {
            const isGoogleConnected =
              connectedPlatforms.data["google"] == "connected";
            const isFacebookConnected =
              connectedPlatforms.data["facebook"] == "connected";
            const isZceppaConnected =
              zceppaStatus.data["zceppa_status"] == "On";
            resolve({
              isGoogleConnected,
              isFacebookConnected,
              isZceppaConnected,
            });
          }
        }
      );
    });
  }
  setRatingBySite(response: any) {
    let ratingBySite = [
      {
        platformIcon: "assets/images/googl.png",
        ratings: response.data.google_rating_count,
        isShowRating: this.isGoogleConnected,
        total: response.data.google_total_rating_reviews,
        averageReviewsPerWeek: response.data.google_average_reviews_per_week,
        averageReviewsPerMonth: response.data.google_average_reviews_per_month,
      },
      {
        platformIcon: "assets/images/fb.png",
        ratings: response.data.facebook_rating_count,
        isShowRating: this.isFacebookConnected,
        total: response.data.facebook_total_rating_reviews,
        averageReviewsPerWeek: response.data.facebook_average_reviews_per_week,
        averageReviewsPerMonth: response.data.facebook_average_reviews_per_month,
      },
      {
        platformIcon: "assets/images/favicon.png",
        ratings: response.data.internal_rating_count,
        isShowRating: this.isZceppaConnected,
        total: response.data.zceppa_total_rating_reviews,
        averageReviewsPerWeek: response.data.zceppa_average_reviews_per_week,
        averageReviewsPerMonth: response.data.zceppa_average_reviews_per_month,
      },
    ].filter((rating) => rating.isShowRating);
    return ratingBySite;
  }

  get outlet_id() {
    return this.storage.get("outlet_id");
  }

  getRatingBySite() {
    this.loading = true;
    let res: Response;

    const data_service = this.httpService.getRequest({
      customApiUrl: this.BASE_URL.RATING_BY_SITE_URL(this.outlet_id),
      start: this.startDate,
      end: this.endDate,
    });
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {},
      () => {
        this.reviewsByRating = this.setRatingBySite(res);
        this.ratingValueApiResponseChange.emit(res?.data);

        this.loading = false;
      }
    );
  }
}
